import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { APP_BASE_PATH } from './paths';
import { parseAppSearch, stringifyAppSearch } from './searchSerialization';

export const router = createRouter({
  routeTree,
  basepath: APP_BASE_PATH,
  parseSearch: parseAppSearch,
  stringifySearch: stringifyAppSearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
